import { Button, Typography } from '@mui/material';
import { GoogleMap, InfoWindowF, Marker } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import blackBridge from 'assets/icons/bridges/black-bridge.png';
import pinPosition from 'assets/icons/pin-position.svg';
import { Rate } from 'components';
import { colors, InspectionStatuses } from 'constants/colors';
import { refreshS3Path } from 'utils/upload';
import { mapCustomStyle } from './mapCustomStyles';
import {
  CardContent,
  CardImage,
  CardImageLabel,
  CardPosisiton,
  CardText,
  Status,
  StatusContainer,
} from './marker.styles';

const Map = ({ lat, lng, center, setCenter, markersDefault, hasMarkers }) => {
  //const navigate = useNavigate();
  const [map, setMap] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);

  const onLoad = useCallback(map => setMap(map), []);

  const defaultCenter = { lat: 41.87194, lng: 12.56738 };

  // const getToDetail = url => {
  //   navigate(url);
  // };

  useEffect(() => {
    if (map && !hasMarkers) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend({
        lat: lat !== 0 ? lat : defaultCenter.lat,
        lng: lng !== 0 ? lng : defaultCenter.lng,
      });

      map.fitBounds(bounds);
      map.setZoom(12);
      setCenter({ lat: +lat, lng: +lng });
    }
  }, [map, lat, lng, hasMarkers]);

  useEffect(() => {
    if (map && hasMarkers && markersDefault) {
      const bounds = new window.google.maps.LatLngBounds();
      markersDefault?.map(({ position }) => bounds.extend(position));
      map.fitBounds(bounds);
      map.setCenter(bounds);
    }
  }, [map, markersDefault, hasMarkers]);

  // const handleOnLoad = map => {
  //   const bounds = new window.google.maps.LatLngBounds();
  //   markersDefault.map(({ position }) => bounds.extend(position));
  //   map.fitBounds(bounds);
  //   map.setCenter(bounds);
  //   // setCenter({ lat: lat, lng: lng });
  //   // map.setZoom(12);
  // };

  const formatStructureName = name => {
    let structureName;
    const splitTitle = name.split(' ');
    const foundLongWord = splitTitle.some(word => word.length > 16);
    const indexLongWord = splitTitle.findIndex(word => word.length > 16);
    if (foundLongWord) {
      indexLongWord === 0
        ? (structureName = name?.substring(0, 16).concat('...'))
        : (structureName = name?.substring(0, 21).concat('...'));
    } else if (name?.length > 50) {
      structureName = name?.substring(0, 40).concat('...');
    } else {
      structureName = name;
    }
    return structureName;
  };

  const renderImage = (image, cda) => {
    return (
      <CardImage>
        <img src={refreshS3Path(image)} alt={markersDefault.name || ''} />
        {cda && (
          <CardImageLabel cda={cda}>
            <label>CdA</label>
          </CardImageLabel>
        )}
      </CardImage>
    );
  };

  return (
    <>
      <GoogleMap
        options={{
          styles: mapCustomStyle,
        }}
        onLoad={onLoad}
        // onCenterChanged={() => setCenter(mapRef.getCenter().toJSON())}
        onClick={e => setCenter(e.latLng.toJSON())}
        mapContainerStyle={{
          margin: '10px',
          width: '98%',
          height: '50vh',
          boxShadow: `0px 0px 0px 8px ${colors.WHITE}`,
          borderRadius: '8px',
        }}
        zoom={4}
        mapTypeId="roadmap"
        clickableIcons={false}
      >
        {!hasMarkers && (
          <Marker
            position={
              center?.lat !== 0 && center?.lng !== 0 ? center : defaultCenter
            }
            icon={blackBridge}
          />
        )}

        {markersDefault?.map(
          (
            {
              position,
              icon,
              url,
              name,
              status,
              lastInspectionDate,
              council,
              involvedLevelsColors,
              image,
              cda,
            },
            index
          ) => {
            return (
              <Marker
                key={index}
                position={position}
                icon={icon}
                onClick={() =>
                  setSelectedMarker({
                    position,
                    url,
                    name,
                    status,
                    lastInspectionDate,
                    council,
                    involvedLevelsColors,
                    image,
                    cda,
                  })
                }
              />
            );
          }
        )}
        {selectedMarker && (
          <>
            <InfoWindowF
              position={selectedMarker.position}
              onCloseClick={() => setSelectedMarker(null)}
            >
              <div style={{ maxWidth: selectedMarker?.image ? 425 : 225 }}>
                <StatusContainer>
                  <Status
                    color={
                      selectedMarker?.status
                        ? InspectionStatuses[selectedMarker.status].labelColor
                        : colors.BLUE
                    }
                  />
                  <Typography variant="body" sx={{ fontSize: '0.75rem' }}>
                    {selectedMarker?.status
                      ? InspectionStatuses[selectedMarker.status].labelCardText
                      : 'ND'}
                  </Typography>
                </StatusContainer>

                <CardContent>
                  {selectedMarker?.image
                    ? renderImage(selectedMarker?.image, selectedMarker?.cda)
                    : ''}

                  <CardText>
                    <Typography variant="body" fontSize={10}>
                      {selectedMarker.lastInspectionDate}
                    </Typography>
                    <Typography
                      variant="h5"
                      style={{ fontSize: 18, fontWeight: 'bold' }}
                      marginTop={1}
                      marginBottom={1.5}
                    >
                      {formatStructureName(selectedMarker.name)}
                    </Typography>
                    <CardPosisiton>
                      <Typography variant="body" fontSize={10}>
                        <img src={pinPosition} alt="" />
                        {selectedMarker?.council || ''}
                      </Typography>
                    </CardPosisiton>
                    <Rate rating={selectedMarker.involvedLevelsColors} />
                  </CardText>
                </CardContent>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  onClick={() => window.open(`${selectedMarker.url}`, '_blank')}
                >
                  {'Vai al dettaglio'}
                </Button>
              </div>
            </InfoWindowF>
          </>
        )}
      </GoogleMap>
    </>
  );
};

Map.defaultValue = {
  markersDefault: [],
  hasMarkers: false,
};

Map.propTypes = {
  markersDefault: PropTypes.array,
  lat: PropTypes.number,
  lng: PropTypes.number,
  center: PropTypes.object,
  setCenter: PropTypes.func,
  hasMarkers: PropTypes.bool,
};

export { Map };
